<template>
  <el-dialog
    title="取消订单"
    :visible.sync="dialog"
    width="30%"
    @close="closeDialog(0)"
  >
    <el-form :model="cancelForm">
      <el-form-item label="取消原因" :label-width="formLabelWidth">
        <el-select
          v-model="cancelForm.cancel_reason"
          placeholder="请选择取消订单的理由"
        >
          <!-- <el-option label="订单超时" value="shanghai"></el-option> -->
          <el-option
            v-for="(item, index) in cancelReasonList"
            :key="index"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="详细说明" :label-width="formLabelWidth">
        <el-input
          type="textarea"
          v-model="cancelForm.cancel_desc"
          placeholder="200字以内"
          style="width:320px"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog(0)">取 消</el-button>
      <el-button type="primary" @click="cancelOrder()">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { CancelReason, Cancel } from "@/api/order";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    OrderSn: {
      type: String,
      default: ""
    }
  },
  watch: {
    showDialog(val) {
      this.dialog = val;
    }
  },
  data() {
    return {
      cancelReasonList: [],
      cancelForm: {},
      formLabelWidth: "120px",
      dialog: false
    };
  },
  mounted() {
    this.getCancelReasonList();
  },
  methods: {
    closeDialog(rel) {
      //参数：0-不刷新；1-刷新订单列表
      var v = "";
      if (rel == 1) {
        v = "1";
      }
      this.$emit("closeDialog", v);
    },
    getCancelReasonList() {
      CancelReason({ token: this.token, app_id: this.app_id }).then(res => {
        this.cancelReasonList = res.data;
      });
    },
    cancelOrder() {
      var data = Object.assign({}, this.cancelForm);
      data.token = this.token;
      data.ordersn = this.OrderSn;
      data.app_id = this.app_id;
      Cancel(data).then(res => {
        this.$message(res.msg);
        if (res.code == 0) {
          this.closeDialog(1);
        } else {
          this.closeDialog(0);
        }
      });
      this.closeDialog(1);
    }
  }
};
</script>
<style scoped></style>
